var _circle, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPorterAlert2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    fill: "#F7F7F7"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#F7F7F7",
    d: "M5 5h14v14H5z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 4.167A5.833 5.833 0 0 0 6.167 10c0 .702.253 1.516.61 2.334.363.828.856 1.708 1.384 2.554 1.057 1.694 2.278 3.292 2.946 4.135a1.136 1.136 0 0 0 1.787 0c.668-.843 1.89-2.441 2.946-4.135.528-.846 1.02-1.726 1.383-2.554.358-.818.61-1.632.61-2.334A5.833 5.833 0 0 0 12 4.167zm0 2.666a2.833 2.833 0 1 0 0 5.667 2.833 2.833 0 0 0 0-5.667z",
    fill: "#6C7C8C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPorterAlert2);
export default __webpack_public_path__ + "static/media/porter_alert2.3ad61fecf96cca326706b33912f56cad.svg";
export { ForwardRef as ReactComponent };